import { z } from 'zod'

import { ConceptChipSchema } from '~/@entities/ConceptChip'
import { CurriculumTypeSchema } from '~/@entities/Curriculum'
import { LessonClassSchema } from '~/@entities/LessonClass'

// 챌린지가 걸린 반은 id·이름만 싣는다
const _LessonClassSchema = LessonClassSchema.pick({ id: true, name: true })

export const ChallengeChapterSchema = z.object({
  trieKey: z.string(),
  conceptChips: z.array(ConceptChipSchema),
})
export type ChallengeChapter = z.infer<typeof ChallengeChapterSchema>

export const AssignedChallengeSchema = z.object({
  lessonClass: _LessonClassSchema,
  chapters: z.array(ChallengeChapterSchema),
})
export type AssignedChallenge = z.infer<typeof AssignedChallengeSchema>

export const AssignedChallengesSchema = z.object({
  challenges: z.array(AssignedChallengeSchema),
})
export type AssignedChallenges = z.infer<typeof AssignedChallengesSchema>

/***************** 반의 챌린지 설정 *****************/
// 선생님이 반에 거는 챌린지. 설정은 교육과정 트리의 한 층에 매이고, 그 아래 유형칩을 고른다.

/** 반에 걸린 챌린지 설정 한 건. relationId 는 relationType 층의 교육과정 id 다 */
export const LessonClassChallengeSettingSchema = z.object({
  id: z.number(),
  relationId: z.number(),
  relationType: CurriculumTypeSchema,
})
export type LessonClassChallengeSetting = z.infer<typeof LessonClassChallengeSettingSchema>

/** 챌린지 설정을 저장한 결과 */
export const SavedLessonClassChallengeSettingSchema = z.object({
  id: LessonClassChallengeSettingSchema.shape.id,
  curriculumId: z.number(),
  curriculumType: CurriculumTypeSchema,
})
export type SavedLessonClassChallengeSetting = z.infer<
  typeof SavedLessonClassChallengeSettingSchema
>
